/**
 * Чистая логика «маршрут до укрытия» для главной страницы и SOS (City
 * Resilience Hack, 24.09.2026): уличное плечо через /api/route-ext (как
 * use-external-escape.ts), а если провайдер не ответил — честная прямая
 * линия с подписью (пункт 6 задачи «главная страница»).
 */
import type { LonLat } from '@app/geo'
import type { ExternalLeg } from '../route-splice'

export interface ShelterRoute {
  /** Точки линии на карте: либо полилиния провайдера, либо [ты, укрытие]. */
  readonly coordinates: readonly LonLat[]
  /** true — линия не по дорогам, а «по прямой» (провайдер недоступен). */
  readonly straight: boolean
}

/** Собрать линию до укрытия; null — нет ни своей позиции, ни цели. */
export function buildShelterRoute(
  you: LonLat | null,
  shelter: LonLat | null,
  leg: ExternalLeg | null,
): ShelterRoute | null {
  if (!you || !shelter) return null
  if (leg && leg.polyline.length >= 2) return { coordinates: leg.polyline, straight: false }
  return { coordinates: [you, shelter], straight: true }
}
